/**
 * Created by Gaplo917 on 5/9/2017.
 */
import * as PIXI from 'pixi.js'
import Image from "../../objects/Image";
import R from "../../config/R";

export class BannerText extends PIXI.Container {
  constructor(x,y, text = '',resources){
    super()
    this.x = x
    this.y = y
    const textStyle = {
      ...new PIXI.TextStyle(R.textStyles.chinese(70)),
      stroke: '#fff',
      fill: '#000',
      dropShadowColor: '#ffffff',
      dropShadow: true,
      dropShadowBlur: 40,
      dropShadowAngle: 0,
      dropShadowDistance: 0,
      strokeThickness: 10,
      lineJoin : 'round',
      padding: 100
    }

    //const questionBox = new PIXI.Sprite(resources[R.images.questionBox.name].texture)
    //questionBox.anchor.x = 0.5
    //questionBox.anchor.y = 0.5

    const text3 = new PIXI.Text(text, textStyle)
    // text3.x = -50
    // text3.anchor.x = 0.5
    // text3.anchor.y = 0.5

    //this.addChild(questionBox)
    this.addChild(text3)
    this.text3 = text3
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/common/BannerText.js